import http from 'hub-http/clients/apiClient';
import { registerMutation, useMutation } from '../../../utils/DataFetchingClient';
import { BASE_URI_PROGRESS } from '../../../constants/uri';
export const START_SHORT_PROGRESS = registerMutation({
  fieldName: 'startShortProgress',
  args: ['language', 'shortId', 'playlistId'],
  fetcher({
    language,
    shortId,
    playlistId
  }) {
    return http.post(`${BASE_URI_PROGRESS}/asset-progress/start/shorts/${shortId}`, {
      data: {
        playlistId,
        language
      }
    });
  }
});
export const useStartShortProgress = () => {
  return useMutation(START_SHORT_PROGRESS);
};